export enum ProfileActionType {
  SAVE_PERSONAL_INFO = 'PROFILE/SAVE_PERSONAL_INFO',
  SAVE_PERSONAL_INFO_SUCCESS = 'PROFILE/SAVE_PERSONAL_INFO_SUCCESS',
  SAVE_PERSONAL_INFO_ERROR = 'PROFILE/SAVE_PERSONAL_INFO_ERROR',
  CLEAN_PROFILE_SUCCESS = 'PROFILE/CLEAN_PROFILE_SUCCESS',
  CHANGE_PASSWORD = 'PROFILE/CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS = 'PROFILE/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_ERROR = 'PROFILE/CHANGE_PASSWORD_ERROR',
  SHOW_EDIT_PERSONAL_INFO = 'PROFILE/SHOW_EDIT_PERSONAL_INFO',
  SHOW_CHANGE_PASSWORD = 'PROFILE/SHOW_CHANGE_PASSWORD',
  TWO_FACTOR_SETUP = 'PROFILE/TWO_FACTOR_SETUP',
  TWO_FACTOR_SETUP_SUCCESS = 'PROFILE/TWO_FACTOR_SETUP_SUCCESS',
  TWO_FACTOR_SETUP_ERROR = 'PROFILE/TWO_FACTOR_SETUP_ERROR',
  TWO_FACTOR_CONFIRM = 'PROFILE/TWO_FACTOR_CONFIRM',
  TWO_FACTOR_CONFIRM_SUCCESS = 'PROFILE/TWO_FACTOR_CONFIRM_SUCCESS',
  TWO_FACTOR_CONFIRM_ERROR = 'PROFILE/TWO_FACTOR_CONFIRM_ERROR',
  TWO_FACTOR_DISABLE = 'PROFILE/TWO_FACTOR_DISABLE',
  TWO_FACTOR_DISABLE_SUCCESS = 'PROFILE/TWO_FACTOR_DISABLE_SUCCESS',
  TWO_FACTOR_DISABLE_ERROR = 'PROFILE/TWO_FACTOR_DISABLE_ERROR',
  CLEAN_TWO_FACTOR_STATE = 'PROFILE/CLEAN_TWO_FACTOR_STATE',
}

export const savePersonalInfo = (name: string, language: string, marketingConsent: boolean) => ({
  type: ProfileActionType.SAVE_PERSONAL_INFO,
  name,
  language,
  marketingConsent,
});

export const savePersonalInfoSuccess = (response: any) => ({
  type: ProfileActionType.SAVE_PERSONAL_INFO_SUCCESS,
  response,
});

export const savePersonalInfoError = (error: any) => ({
  type: ProfileActionType.SAVE_PERSONAL_INFO_ERROR,
  error,
});

export const cleanProfileSuccess = () => ({
  type: ProfileActionType.CLEAN_PROFILE_SUCCESS,
});

export const changePassword = (oldPassword: string, newPassword: string) => ({
  type: ProfileActionType.CHANGE_PASSWORD,
  oldPassword,
  newPassword,
});

export const changePasswordSuccess = (response: any) => ({
  type: ProfileActionType.CHANGE_PASSWORD_SUCCESS,
  response,
});

export const changePasswordError = (error: any) => ({
  type: ProfileActionType.CHANGE_PASSWORD_ERROR,
  error,
});

export const openEditPersonalInfo = (show: boolean) => ({
  type: ProfileActionType.SHOW_EDIT_PERSONAL_INFO,
  show,
});

export const openChangePassword = (show: boolean) => ({
  type: ProfileActionType.SHOW_CHANGE_PASSWORD,
  show,
});

export const setupTwoFactor = () => ({
  type: ProfileActionType.TWO_FACTOR_SETUP,
});

export const setupTwoFactorSuccess = (response: any) => ({
  type: ProfileActionType.TWO_FACTOR_SETUP_SUCCESS,
  response,
});

export const setupTwoFactorError = (error: any) => ({
  type: ProfileActionType.TWO_FACTOR_SETUP_ERROR,
  error,
});

export const confirmTwoFactor = (code: string) => ({
  type: ProfileActionType.TWO_FACTOR_CONFIRM,
  code,
});

export const confirmTwoFactorSuccess = () => ({
  type: ProfileActionType.TWO_FACTOR_CONFIRM_SUCCESS,
});

export const confirmTwoFactorError = (error: any) => ({
  type: ProfileActionType.TWO_FACTOR_CONFIRM_ERROR,
  error,
});

export const disableTwoFactor = (code: string) => ({
  type: ProfileActionType.TWO_FACTOR_DISABLE,
  code,
});

export const disableTwoFactorSuccess = () => ({
  type: ProfileActionType.TWO_FACTOR_DISABLE_SUCCESS,
});

export const disableTwoFactorError = (error: any) => ({
  type: ProfileActionType.TWO_FACTOR_DISABLE_ERROR,
  error,
});

export const cleanTwoFactorState = () => ({
  type: ProfileActionType.CLEAN_TWO_FACTOR_STATE,
});
